import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import reduxThunk from 'redux-thunk';
import { composeWithDevTools } from '@redux-devtools/extension';
import reducers from '../reducers';
import { RootState } from '../reducers/index.types';
import { applyMiddleware, createStore } from 'redux';

const store =
  process.env.NODE_ENV !== 'production'
    ? createStore(reducers, composeWithDevTools(applyMiddleware(reduxThunk)))
    : applyMiddleware(reduxThunk)(createStore)(reducers);

export default store;

export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
